module.exports = __webpack_public_path__ + "static/media/Ateliers_pelissou.7ece01e2.svg";